import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { SvgIconProps } from '@mui/material';


interface CustomIconProps extends SvgIconProps {
    testId: string;
}

const CustomArrowIcon = ({ testId, ...props }: CustomIconProps) => (
    <ArrowDropDownIcon
        {...props}
        data-testid={testId}
    />
);

export default CustomArrowIcon;